export default function Hero() {
  return (
    <section id="hero" className="relative w-full pt-[72px] min-h-[600px] md:min-h-[680px] bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-600 bg-primary-100/80 rounded-full mb-5">
              全网最全高清影视平台
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-5">
              91免费在线视频
              <br />
              <span className="text-primary-500">麻豆精品影视</span>
              高清在线观看
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              海量国产精品视频、热门电视剧全集免费在线看。每日同步更新最新影视资源，麻豆传媒独家系列、九色专题一站尽览。
              支持4K超清画质、多线路自动切换，无需缓冲、纯净无广告，为您打造极致的在线观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">10000+</div>
                <div className="text-xs text-foreground-500 mt-1">高清影片资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步追剧不停</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">4K HDR</div>
                <div className="text-xs text-foreground-500 mt-1">超清视觉盛宴</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all cursor-pointer text-center"
              >
                开始观影
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#features"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 text-sm font-medium text-foreground-700 bg-background-100 hover:bg-background-200 rounded-full transition-colors cursor-pointer text-center"
              >
                了解平台优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px]">
              <div className="aspect-[4/3] w-full rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20and%20entertainment%20collage%2C%20warm%20golden%20and%20crimson%20abstract%20composition%2C%20movie%20elements%20floating%20with%20dramatic%20spotlight%2C%20luxurious%20cinema%20aesthetic%2C%20elegant%20curved%20shapes%2C%20premium%20streaming%20platform%20visual&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                  alt="91免费在线视频 - 麻豆精品影视高清在线观看"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 md:w-28 md:h-28 bg-accent-500 rounded-2xl flex flex-col items-center justify-center">
                <span className="text-lg md:text-xl font-heading font-bold text-background-50">HD</span>
                <span className="text-xs text-background-50/80">4K</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}